module.exports = __webpack_public_path__ + "media/images/lp_v6_img10-bce37feeab58719ac4ab839b93ebd508.webp";